import { initializeApp, getApps, type FirebaseApp as AuthSdkApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  type Auth,
} from 'firebase/auth';
import { getAnalytics, isSupported, type Analytics } from 'firebase/analytics';

const appConfig = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId:             import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId:     import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const authApp: AuthSdkApp =
  getApps()[0] ?? initializeApp(appConfig);

export const authClient: Auth = getAuth(authApp);

export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

// Analytics requires browser APIs (window, cookies). Guard so SSR / tests
// don't blow up, and skip in dev unless explicitly enabled.
export let analyticsClient: Analytics | null = null;
if (typeof window !== 'undefined' && appConfig.measurementId) {
  isSupported()
    .then((ok) => {
      if (ok) analyticsClient = getAnalytics(authApp);
    })
    .catch(() => {
      /* analytics is optional — silently ignore */
    });
}
